import { queryApi } from "src/utils/api/ApiMethods"

export const fetchAccess = async ({ marinaSlug }) => {
  return queryApi(`/manage/${marinaSlug}/point_of_sale/access.json`)
}
